import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Kpi } from '@tran-monorepo/interfaces/applications';
import { EMPTY, Observable } from 'rxjs';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { KpisService } from '../../services';
import { LoadAllKpis } from './kpis.actions';

export interface KpisStateModel {
    loading: boolean;
    kpis: Kpi[];
}

@State<KpisStateModel>({
    name: 'kpis',
    defaults: {
        loading: false,
        kpis: []
    }
})
@Injectable()
export class KpisState {
    private readonly kpisService = inject(KpisService);

    @Selector()
    static kpis(state: KpisStateModel): Kpi[] {
        return state.kpis;
    }

    @Selector()
    static loading(state: KpisStateModel): boolean {
        return state.loading;
    }

    @Action(LoadAllKpis)
    loadAll(ctx: StateContext<KpisStateModel>): Observable<void> {
        ctx.patchState({ loading: true, kpis: [] });

        return this.kpisService.getKpis().pipe(
            map(kpis =>
                kpis.map(kpi => ({
                    id: kpi.id,
                    name: kpi.name,
                    definition: kpi.name,
                    startUnit: null,
                    targetUnit: null
                }))
            ),
            tap(kpis => ctx.patchState({ kpis })),
            map(() => void 0),
            catchError(() => {
                ctx.patchState({ kpis: [] });
                return EMPTY;
            }),
            finalize(() => ctx.patchState({ loading: false }))
        );
    }
}
